// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaregiverLine-module__root___AJpxV {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 4px 0 0;
  font-size: 12px;
}

.CaregiverLine-module__large___JH4CN {
  font-size: 14px;
  line-height: 1.5;
}

.CaregiverLine-module__flush___fIozx {
  margin-top: 0;
}

.CaregiverLine-module__icon___c0317 {
  flex-shrink: 0;
  margin-top: 2px;
}

.CaregiverLine-module__toneOk___SDIDm {
  color: #3f3f46;
}

.CaregiverLine-module__toneWarn___LUeGB {
  font-weight: 500;
  color: #a16207;
}

.CaregiverLine-module__toneNone___fWcLZ {
  color: #a1a1aa;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/CaregiverLine.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".root {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin: 4px 0 0;\n  font-size: 12px;\n}\n\n.large {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.flush {\n  margin-top: 0;\n}\n\n.icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.toneOk {\n  color: #3f3f46;\n}\n\n.toneWarn {\n  font-weight: 500;\n  color: #a16207;\n}\n\n.toneNone {\n  color: #a1a1aa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaregiverLine-module__root___AJpxV`,
	"large": `CaregiverLine-module__large___JH4CN`,
	"flush": `CaregiverLine-module__flush___fIozx`,
	"icon": `CaregiverLine-module__icon___c0317`,
	"toneOk": `CaregiverLine-module__toneOk___SDIDm`,
	"toneWarn": `CaregiverLine-module__toneWarn___LUeGB`,
	"toneNone": `CaregiverLine-module__toneNone___fWcLZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
